export default __webpack_public_path__ + "static/media/gisira.05acc978.png";